import * as url from "./route_url"


//****************************Dashboard ************************************** */
export const DASHBORD_1 = url.DASHBORD_1

// ***************************** Utility **************************************//

export const SEARCH_BOX2 = "/SearchBoxSecond"
export const SEARCH_BOX3 = "/SerachBox3"

// *************************** Administration *******************************//

export const ModuleMaster = url.MODULE_lIST
export const ModuleList = url.MODULE

export const CompanyMaster = url.COMPANY_lIST
export const CompanyList = url.COMPANY

export const UserMaster = url.USER_lIST
export const UserList = url.USER

export const RoleMaster = url.ROLE_lIST
export const RoleList = url.ROLE

export const Scheme_Master = url.SCHEME_MASTER_LIST
export const Scheme_Master_List = url.SCHEME_MASTER

export const RoleAccess = url.ROLEACCESS_lIST
export const RoleAccessList = url.ROLEACCESS

export const VendorProduction = url.VENDOR_PRODUCTION_LIST
export const VendorProductionList = url.VENDOR_PRODUCTION

export const COPY_ROLEACCESS = "/RoleAccessCopyFunctionality"

// *************************** Master Module **********************************//

export const ItemMaster = url.ITEM_lIST
export const ItemList = url.ITEM

export const GSTMaster = url.GST_LIST
export const GSTList = url.GST

export const CompanyGroupMaster = url.COMPANYGROUP_lIST
export const CompanyGroupList = url.COMPANYGROUP

export const EmployeeMaster = url.EMPLOYEE_lIST
export const EmployeeList = url.EMPLOYEE

export const EmployeeType = url.EMPLOYEETYPE_lIST
export const EmployeeTypeList = url.EMPLOYEETYPE

export const CategoryTypeMaster = url.CATEGORYTYPE_lIST
export const CategoryTypeList = url.CATEGORYTYPE

export const DriverMaster = url.DRIVER_lIST
export const DriverList = url.DRIVER

export const PartyMaster = url.PARTY_lIST
export const PartyList = url.PARTY

export const Non_Retailer_Party = url.NON_RETAILER_PARTY_lIST
export const Non_Retailer_Party_List = url.NON_RETAILER_PARTY

export const PartySelfEdit = url.PARTY_SELF_EDIT

export const PartyType = url.PARTYTYPE_lIST
export const PartyTypeList = url.PARTYTYPE

export const CategoryMaster = url.CATEGORY_lIST
export const CategoryList = url.CATEGORY

export const VehicleMaster = url.VEHICLE_lIST
export const VehicleList = url.VEHICLE

export const RoutesMaster = url.ROUTES_LIST
export const RoutesList = url.ROUTES

export const SalesManMaster = url.SALESMAN_LIST
export const SalesManList = url.SALESMAN

export const GroupTypeMaster = url.GROUPTYPE_lIST
export const GroupTypeList = url.GROUPTYPE

export const GroupMaster = url.GROUP_lIST
export const GroupList = url.GROUP

export const PriceMaster = url.PRICE_lIST
export const PriceList = url.PRICE

export const MRPMaster = url.MRP_lIST
export const MRPList = url.MRP

export const MarginMaster = url.MARGIN_lIST
export const MarginList = url.MARGIN

export const PageMaster = url.PAGE_lIST
export const PageList = url.PAGE

export const TermsAndCondtionsMaster = url.TERMS_AND_CONDITION_LIST;
export const TermsAndCondtionsList = url.TERMS_AND_CONDITION;

export const PartySubParty = url.PARTY_SUB_PARTY_lIST;
export const PartySubPartyList = url.PARTY_SUB_PARTY;

export const SubGroupList = url.SUBGROUP
export const SubGroupMaster = url.SUBGROUP_LIST

export const GeneralList = url.GENERAL
export const GeneralMaster = url.GENERAL_LIST

export const CityList = url.CITY
export const CityMaster = url.CITY_LIST


export const ImportFieldMap = url.IMPORT_EXCEL_FIELD_MAP
export const ImportFieldMapList = url.IMPORT_EXCEL_FIELD_MAP

export const ImportFieldAdd = url.IMPORT_FIELD_ADD_LIST
export const ImportFieldAddList = url.IMPORT_FIELD_ADD

export const RouteUpdate = url.ROUTE_UPDATE

export const PartyMasterBulkUpdate = url.PARTY_MASTER_BULK_UPDATE

export const ManagementParties = url.MANAGEMENT_PARTIES

export const BankMaster = url.BANK_LIST
export const BankList = url.BANK

export const Pos_Setting = url.POS_SERVICE_SETTING_LIST
export const Pos_Setting_List = url.POS_SERVICE_SETTING

export const RetailerMaster = url.RETAILER_LIST
export const RetailerList = url.RETAILER_MASTER


export const Retailer_Master_1 = url.RETAILER_MASTER_LIST_1
export const Retailer_Master_List_1 = url.RETAILER_MASTER_1



export const ProductMarginReport = url.PRODUCT_MARGIN_REPORT

export const Discount_Master = url.DISCOUNT_LIST
export const Discount_List = url.DISCOUNT_MASTER

export const Cluster_Master = url.CLUSTER_lIST
export const Cluster_List = url.CLUSTER_MASTER

export const SubCluster_Master = url.SUB_CLUSTER_lIST
export const SubCluster_List = url.SUB_CLUSTER_MASTER

export const CentralServiceItem = url.CENTRAL_SERVICE_ITEM_lIST
export const CentralServiceItemList = url.CENTRAL_SERVICE_ITEM_MASTER

export const SERVICE_ITEM_ASSIGN = url.SERVICE_ITEM_ASSIGN

export const Party_Details = url.PARTY_DETAILS

export const ItemMasterBulkUpdate = url.ITEM_MASTER_BULK_UPDATE

export const Item_Supplier_Assign = url.ITEM_SUPPLIER_ASSIGN

export const Rate_Master = url.RATE_LIST
export const Rate_List = url.RATE_MASTER

export const Franchise_Customer_Master = url.FRANCHISE_CUSTOMER_LIST

export const Franchise_Customer_List = url.FRANCHISE_CUSTOMER_MASTER

export const Country_Master = url.COUNTRY_LIST
export const Country_List = url.COUNTRY_MASTER

export const Voucher = url.VOUCHER_LIST
export const Voucher_List = url.VOUCHER

export const VDC_Invoice = url.VDC_INVOICE_LIST
export const VDC_Invoice_List = url.VDC_INVOICE


//******************************* Purchase Module ************************************//

export const OrderList_1 = url.ORDER_1;
export const Order_1 = url.ORDER_LIST_1;

export const OrderList_2 = url.ORDER_2;
export const Order_2 = url.ORDER_LIST_2;

export const OrderList_4 = url.ORDER_4;
export const Order_4 = url.ORDER_LIST_4;

export const PurchaseReturnList = url.PURCHASE_RETURN;
export const PurchaseReturn = url.PURCHASE_RETURN_LIST;

//******************************* Production ************************************//

export const BOMList = url.BIllOf_MATERIALS;
export const BOM = url.BIllOf_MATERIALS_LIST;

export const WorkOrderList = url.WORK_ORDER;
export const WorkOrder = url.WORK_ORDER_LIST;

export const Scheme_Type = url.SCHEME_TYPE_LIST;
export const Scheme_Type_List = url.SCHEME_TYPE;

export const Generic_POS_Messages_Master_List = url.GENERIC_MESSAGE_MASTER;
export const Generic_POS_Messages_Master = url.GENERIC_MESSAGE_LIST;

export const NocListPage = url.NOC_DOCUMENT_UPLOAD;
export const NocDocumentUpload = url.NOC_LIST_PAGE;

export const WastageList = url.WASTAGE_ENTRY_MASTER;
export const WastageEntryMaster = url.WASTAGE_LIST;

export const Bulk_Work_Order_List = url.BULK_WORK_ORDER;
export const Bulk_Work_Order = url.BULK_WORK_ORDER_LIST;

export const MaterialIssueList = url.MATERIAL_ISSUE_STP;
export const MaterialIssue = url.MATERIAL_ISSUE_LIST;
export const MaterialIssue_STP = url.MATERIAL_ISSUE_LIST;

export const ProductionReIssue = url.PRODUCTION_REISSUE_LIST;
export const ProductionReIssueList = url.PRODUCTION_REISSUE;
export const ProductionReIssue_STP = url.PRODUCTION_REISSUE_STP;

export const ProductionList = url.PRODUCTION_STP;
export const ProductionMaster = url.PRODUCTION_LIST;
export const Production_STP = url.PRODUCTION_LIST;

//******************************* Inventory ************************************//


export const GRN_ADD_1 = url.GRN_LIST_3;

export const GRN_STP_1 = url.GRN_LIST_1;


export const GRNList_3 = url.GRN_STP_3;
export const GRN_ADD_3 = url.GRN_LIST_3;
export const GRN_STP_3 = url.GRN_LIST_3;

export const GRN_LIST_1 = url.IB_GRN_LIST;
export const IB_GRN_List = url.GRN_LIST_1;



export const IB_GRN_LIST = url.IB_GRN;

export const IB_GRN = url.IB_GRN_LIST;

export const IB_INVOICE_FOR_GRN = url.IB_GRN_LIST;



export const Accounting_GRN = url.ACCOUNTING_GRN_LIST;
export const Accounting_GRN_List = url.ACCOUNTING_GRN;
export const GRN_For_Accounting_GRN = url.ACCOUNTING_GRN_LIST;



export const Stock_Entry_List = url.STOCK_ENTRY;
export const Stock_Entry = url.STOCK_ENTRY_LIST;

export const ChallanList = url.IB_INVOICE;
export const Challan = url.IB_INVOICE_LIST;

export const StockAdjustment = url.STOCK_ADJUSTMENT_LIST
export const Stock_Adjustment_List = url.STOCK_ADJUSTMENT

export const STOCK_ADJUSTMENT_MODE = url.STOCK_ADJUSTMENT_MODE_2

//******************************* Inter Branch ************************************//

export const IB_ORDER_PO_LIST = url.IB_ORDER;
export const IB_Order = url.IB_ORDER_PO_LIST;


export const IB_Order_SO_List = url.IB_SALES_ORDER;
export const IB_Sales_Order = url.IB_ORDER_SO_LIST;



export const InwardList = url.IB_INWARD_STP;
export const Inward = url.INWARD_LIST;
export const IB_INWARD_STP = url.IB_INVOICE_LIST;

export const IB_Invoice_List = url.IB_INVOICE_STP;
export const IB_Invoice = url.IB_INVOICE_LIST;
export const IB_Invoice_STP = url.IB_ORDER_PO_LIST;

//******************************* Sales ************************************//
export const InvoiceList = url.INVOICE_1;
export const Invoice_1 = url.INVOICE_LIST_1;

export const Franchies_Invoice = url.POS_INVOICE_LIST;

export const ListChallan = url.CHALLAN_MASTER
export const MasterChallan = url.CHALLAN_MASTER_LIST

export const InvoiceList_1 = url.CSS_BULK_INVOICE
export const CSSBulkInvoice = url.INVOICE_LIST_1

export const Loading_Sheet_List = url.LOADING_SHEET;
export const Loading_Sheet = url.LOADING_SHEET_LIST;
export const Loading_Sheet_List_Update = url.LOADING_SHEET_LIST;
export const BulkRecipt = url.LOADING_SHEET_LIST;

export const SalesReturn = url.SALES_RETURN_LIST;
export const SalesReturnList = url.SALES_RETURN;

export const Purchase_Return_Mode_3 = url.SALES_RETURN_LIST;

export const Bulk_Invoice = url.BULK_INVOICE

//********************************Accounting ***********************************//
export const Receipts = url.RECEIPTS_LIST;
export const ReceiptList = url.RECEIPTS;
export const ReceiptList_2 = url.RECEIPTS_LIST_2;

export const PaymentEntry = url.PAYMENT_ENTRY_LIST;
export const PaymentEntryList = url.PAYMENT_ENTRY;

export const BankAssign = url.BANK_ASSIGN;

export const Credit = url.CREDIT_LIST;
export const CreditList = url.CREDIT_NOTE;

export const Debit = url.DEBIT_LIST;
export const DebitList = url.DEBIT_NOTE;

export const GoodsCreditNote = url.GOODS_CREDIT_LIST;
export const GoodsCreditNoteList = url.GOODS_CREDIT_NOTE;

export const GoodsDebitNote = url.GOODS_DEBIT_LIST;
export const GoodsDebitNoteList = url.GOODS_DEBIT_NOTE;

export const Credit_Note_1 = url.CREDIT_NOTE_LIST_1
export const Credit_Note_List_1 = url.CREDIT_NOTE_1

export const ClaimTrackingEntry = url.CLAIM_TRACKING_ENTRY_LIST
export const ClaimTrackingEntryList = url.CLAIM_TRACKING_ENTRY

export const System_Setting = url.SYSTEM_SETTING_LIST;
export const System_Setting_List = url.SYSTEM_SETTING;

export const Target_Upload = url.TARGET_UPLOAD_LIST;
export const Target_Upload_List = url.TARGET_UPLOAD;


export const CreditNoteUpload = url.CREDIT_NOTE_UPLOAD

//**************************** Reports ***********************************//

export const OrderSummaryReport = url.ORDER_SUMMARY_REPORT;

export const Generic_Sale_Report = url.GENERIC_SALE_REPORT;

export const RetailerDataReport = url.RETAILER_DATA_REPORT;

export const Damage_Stock_Report = url.DAMAGE_STOCK_REPORT;

export const DeleteInvoiceDataExport = url.DELETE_INVOICE_DATA_EXPORT;

export const Item_Sale_Report = url.ITEM_SALE_REPORT;

export const Claim_Summary_list = url.CLAIM_SUMMARY_MASTER;

export const Claim_Summary_Master = url.CLAIM_SUMMARY_lIST;

export const SapLedger = url.SAP_LEDGER;

export const CurrentStockReport = url.CURRENT_STOCK_REPORT;

export const SNS_Report = url.SNS_REPORT;

export const DebitDataExport = url.DEBIT_DATA_EXPORT

export const CreditDataExport = url.CREDIT_DATA_EXPORT

export const ReceiptDataExport = url.RECEIPT_DATA_EXPORT

export const PartyOutstandingReport = url.PARTY_OUTSTANDING_REPORT

export const RetailerApproval = url.RETAILER_APPROVAL

export const ManPowerReport = url.MAN_POWER_REPORT

export const ClaimTrackingReport = url.CLAIM_TRACKING_REPORT

export const TCSAmountReport = url.TCS_AMOUNT_REPORT

export const CX_DD_Difference = url.CX_DD_DIFFERENCE_REPORT


export const Sales_Order_List_2 = url.APP_ORDER_LIST

export const TargetVSAchievement = url.TARGET_VS_ACHIEVEMENT

export const Credit_Note_Excel_Field_Map = url.IMPORT_CREDIT_NOTE_EXCEL_FIELD_MAP

export const Order_Item_Supplier_Report = url.ORDER_ITEM_SUPPLIER_REPORT

//**************************** POS ***********************************//

export const POS_User = url.POS_USER_lIST
export const POS_User_List = url.POS_USER

export const SweetPOS_Rate_Master = url.SWEET_POS_RATE_MASTER

export const SweetPOS_Machine_List = url.SWEET_POS_MACHINE_MASTER

export const SweetPOS_Machine_Master = url.SWEET_POS_MACHINE_LIST

export const Stock_Out_Report = url.STOCK_OUT_REPORT

export const Franchise_Sale_With_Bill_Count = url.FRANCHAISE_SALE_WITH_BILL_COUNT

export const ERPURMs = url.ERP_URL_L;
export const ERPURLs = url.ERP_URL_M;

export const CashBookHeadList = url.CashBookHead;
export const CashBookHead = url.CashBookHeadList

export const CashBookEntryList = url.CASH_BOOK_ENTRY
export const CashBookEntry = url.CASH_BOOK_ENTRY_LIST